module.exports = __webpack_public_path__ + "static/media/tabela.63c86964.png";